import { render } from "./Login.vue?vue&type=template&id=63155386&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=63155386&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-63155386"

export default script